import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
/* eslint-disable max-len */

export interface IUploadedImageEntityAttributes extends IModelAttributes {
	imageId: string;
	image: Blob;
	description: string;

	headerImageEventDetailId?: string;
	headerImageEventDetail?: Models.EventDetailEntity | Models.IEventDetailEntityAttributes;
	supportingImageEventDetailId?: string;
	supportingImageEventDetail?: Models.EventDetailEntity | Models.IEventDetailEntityAttributes;
}
@entity('UploadedImageEntity', 'Uploaded Image')
export default class UploadedImageEntity extends Model implements IUploadedImageEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	/**
	 * The image that is uploaded.
	 */
	@observable
	@attribute<UploadedImageEntity, string>({ file: 'image' })
	public imageId: string;

	public image: Blob;
	/**
	 * A description for the image.
	 */
	@observable
	@attribute<UploadedImageEntity, string>()
	public description: string;

	@observable
	@attribute()
	public headerImageEventDetailId?: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public headerImageEventDetail: Models.EventDetailEntity;

	@observable
	@attribute()
	public supportingImageEventDetailId?: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public supportingImageEventDetail: Models.EventDetailEntity;

	constructor(attributes?: Partial<IUploadedImageEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IUploadedImageEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.image !== undefined) {
				this.image = attributes.image;
			}
			if (attributes.imageId !== undefined) {
				this.imageId = attributes.imageId;
			}
			if (attributes.description !== undefined) {
				this.description = attributes.description;
			}
			if (attributes.headerImageEventDetailId !== undefined) {
				this.headerImageEventDetailId = attributes.headerImageEventDetailId;
			}
			if (attributes.headerImageEventDetail !== undefined) {
				if (attributes.headerImageEventDetail === null) {
					this.headerImageEventDetail = attributes.headerImageEventDetail;
				} else if (attributes.headerImageEventDetail instanceof Models.EventDetailEntity) {
					this.headerImageEventDetail = attributes.headerImageEventDetail;
					this.headerImageEventDetailId = attributes.headerImageEventDetail.id;
				} else {
					this.headerImageEventDetail = new Models.EventDetailEntity(attributes.headerImageEventDetail);
					this.headerImageEventDetailId = this.headerImageEventDetail.id;
				}
			}
			if (attributes.supportingImageEventDetailId !== undefined) {
				this.supportingImageEventDetailId = attributes.supportingImageEventDetailId;
			}
			if (attributes.supportingImageEventDetail !== undefined) {
				if (attributes.supportingImageEventDetail === null) {
					this.supportingImageEventDetail = attributes.supportingImageEventDetail;
				} else if (attributes.supportingImageEventDetail instanceof Models.EventDetailEntity) {
					this.supportingImageEventDetail = attributes.supportingImageEventDetail;
					this.supportingImageEventDetailId = attributes.supportingImageEventDetail.id;
				} else {
					this.supportingImageEventDetail = new Models.EventDetailEntity(
						attributes.supportingImageEventDetail,
					);
					this.supportingImageEventDetailId = this.supportingImageEventDetail.id;
				}
			}
		}
	}
}
